module.exports = __webpack_public_path__ + "static/media/question-icon.39b6aff7.svg";